import { createContext, useContext } from 'react';
import { FormikProps } from 'formik';
import {
    CaseService,
    CaseTaskService,
    CaseDocumentService,
    CaseEventService,
    CaseNoteService,
    CaseExpenseService,
    TimeTrackingService,
    CaseEngagementService,
    InvoiceService,
    CaseMilestoneService
} from '../../../../data/services';
import { Case } from '../../../../data/types';

export type CaseServicesContextType = {
    caseForm: FormikProps<Case>;
    caseService: CaseService;
    taskService: CaseTaskService;
    documentService: CaseDocumentService;
    eventService: CaseEventService;
    noteService: CaseNoteService;
    expenseService: CaseExpenseService;
    timeTrackingService: TimeTrackingService;
    caseEngagementService: CaseEngagementService;
    invoiceService: InvoiceService;
    milestoneService: CaseMilestoneService;
};

export const CaseServicesContext = createContext<CaseServicesContextType | undefined>(undefined);

export const useCaseServicesContext = () => {
    const context = useContext(CaseServicesContext);
    return context;
};
